import { Link } from 'react-router-dom'
import { useShopifySyncSetting } from '@/hooks/useAdmin'
import { fmtDateTime } from '@/lib/dates'
import { useAuthStore } from '@/store/authStore'

// App-wide notice that the Admin "PO Shopify Sync" switch is off. Amber =
// attention: while it's off, PO changes silently stop reaching Shopify, so
// everyone (not just admins) needs to see it on every page.
export function SyncOffBanner() {
  const { data } = useShopifySyncSetting()
  const isAdmin = useAuthStore((s) => s.user?.role === 'admin')

  // Only an explicit `false` shows the banner — loading/error stays quiet.
  if (data?.enabled !== false) return null

  const since = data.changed_at ? ` since ${fmtDateTime(data.changed_at)}` : ''
  const by = data.changed_by ? ` by ${data.changed_by}` : ''

  return (
    <div
      role="status"
      data-testid="sync-off-banner"
      className="w-full border-b border-[var(--line-warm)] bg-[var(--status-awaiting-bg)] px-[18px] py-1.5 text-xs text-[var(--status-awaiting-fg)]"
    >
      <span className="font-semibold">⚠ Shopify sync is off{since}{by}.</span>{' '}
      Purchase-order changes (ordering, receiving, archiving, PO edits) aren't reaching
      Shopify. Stocktakes and adjustments still sync.
      {isAdmin && (
        <>
          {' '}
          <Link to="/admin" className="font-semibold underline">
            Turn on in Admin
          </Link>
        </>
      )}
    </div>
  )
}
